import { FiatWallet } from "@models";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { AcceptOfferMutation, TradeType } from "@gql/offer";
import { AcceptedOfferWallets } from "@modules/trade/services/trade-offer.service";

// NOTICE: when using this interface please use Partial. e.g Partial<AcceptedOffer>
export interface AcceptedOffer {
	id: string;
	fiatAmount: string;
	assetAmount: string;
	assetId: string;
	walletId: string;
	fiatWalletId: string;
	fiatId: string;
	currencyId: string;
	price: string;
	tradeType: TRADE_TYPE | TradeType;
	assetWallet: TradableWallet;
	fiatWallet: FiatWallet;
	itbAmount: string;
	firstTrade: boolean;
}

/**
 * Deserialize accepted offer adapters
 */
export class AcceptedOfferDeserializer {
	static deserializeGraphQL(acceptedOfferMutation: AcceptOfferMutation["acceptOffer"]): Partial<AcceptedOffer> {
		if (acceptedOfferMutation.__typename === "AcceptOfferSuccessResponse") {
			const success = acceptedOfferMutation.trade;
			return {
				id: success?.tradeId,
				fiatAmount: success?.amountFiat.value,
				assetAmount: success?.amountAsset.value,
				assetId: success?.assetId,
				walletId: success?.assetWallet.id,
				fiatWalletId: success?.fiatWallet.id,
				fiatId: success?.fiatId,
				price: success?.price.value,
				tradeType: success?.type,
				firstTrade: success?.isFirstTrade
			};
		}

		if (acceptedOfferMutation.__typename === "AcceptOfferInProgressResponse") {
			const pending = acceptedOfferMutation.acceptOfferInProgress;

			return {
				fiatAmount: pending?.amountFiat.value,
				assetAmount: pending?.amountAsset.value,
				assetId: pending?.assetId,
				fiatId: pending?.fiatId,
				price: pending?.price.value,
				tradeType: pending?.type
			};
		}
	}

	static deserializeIndexTradeGQL(
		trade: AcceptedOfferWallets | null,
		amount: string,
		tradeType: TRADE_TYPE,
		assetId: string,
		fiatId: string
	): Partial<AcceptedOffer> {
		if (!trade) {
			return {
				fiatAmount: amount,
				id: null,
				fiatId,
				assetId,
				tradeType
			};
		}

		return {
			fiatAmount: amount,
			id: trade.tradeId,
			fiatId: trade.fiatWallet.getFiatId(),
			assetId: trade.assetWallet.getCurrencyId(),
			tradeType
		};
	}
}
